import { bem, Chatter, selectBroadcastGuestsArray } from '@socialive/common';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Timestamp from '../../Utilities/Timestamp';
import './chatMessage.css';
import ChatMessageToken from './ChatMessageToken';
import { messageShape } from './shapes';

/*
#tailwind
chatMessage__metaData chatMessage__sender chatMessage__sender--isMe 
chatMessage__message chatMessage__message--emphasis
*/

function ChatMessage({ message, ...other }) {
  const { message: content, timestamp: time, isMe, name } = message;

  const sender = isMe ? 'Me' : name;

  const guests = useSelector(selectBroadcastGuestsArray);
  const chatter = useMemo(() => Chatter.parse(content, { users: guests }).toJSON(), [content, guests]);
  const emphasis = useMemo(() => chatter.emojiOnly && chatter.emojiCount <= 3, [chatter]);

  return (
    <div className="chatMessage">
      <div className="chatMessage__metaData">
        <span className={bem`chatMessage__sender--${{ isMe }}`}>{sender}</span>
        <span className="chatMessage__timestamp">
          <Timestamp time={time} />
        </span>
      </div>
      <div className={bem`chatMessage__message--${{ emphasis }}`}>
        {chatter.slashShrug && <ChatMessageToken token={chatter.slashShrug} />}
        {chatter.segments.map((segment) => (
          // eslint-disable-next-line react/no-array-index-key
          <ChatMessageToken key={segment.index} token={segment} />
        ))}
        {chatter.shrug && <ChatMessageToken token={chatter.shrug} />}
      </div>
    </div>
  );
}

ChatMessage.propTypes = {
  message: messageShape.isRequired,
};

export default ChatMessage;
